import CommonArrow from './CommonArrow.vue'

export default CommonArrow
